import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';
import { PROJECT_THEME } from '../../theme';
import { Palette } from './helpers';

const paletteFor = (colour: DefaultTheme['colour']): Palette => ({
    colours: colour.PALETTE,
    background: colour.DARK_GREY,
    foreground: colour.OFF_WHITE,
    muted: colour.LIGHT_GREY,
});

export const SERVICE_PALETTE: Palette = paletteFor(PROJECT_THEME.colour);

export const useServicePalette = (): Palette => {
    const { colour } = useTheme();
    return useMemo(() => paletteFor(colour), [colour]);
};
